import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { examTypeDropdown } from "./constant";
export const getDropdowns = async () => {
    const dropdown = await Promise.all([
      dropdownMapping(
        endpoint.academic_career.getAllActive,
        "academicCareerDispValue",
        "id"
      ),
      dropdownMapping(
        endpoint.classes.getAllActive,
        "classDispValue",
        "classKey"
      ),
      dropdownMapping(
        endpoint.academic_group.getAllActive,
        "academicGroupDispValue",
        "academicGroupDispValue",
      ),
      dropdownMapping(
        endpoint.testType.getAllActive,
        "testTypeDispValue",
        "id",
      ),
    
    ]);
    return {
      academicCareer: dropdown[0],
      academicClass: dropdown[1],
      academicStream: dropdown[2],
      examType: dropdown[3],
    };
}
